import { Reveal, Overline } from "./Reveal";

const BLOCKS = [
  { title: "Discrète", text: "À l'intérieur de vos chaussures.", accent: "#A8B89A", bg: "#E7EEE0" },
  { title: "Quotidienne", text: "Pensée pour accompagner les déplacements de tous les jours.", accent: "#D4B3AD", bg: "#F6E5E1" },
  { title: "Lestée", text: "Une charge intégrée directement dans la semelle.", accent: "#C9B79E", bg: "#F4EBDD" },
  { title: "Simple", text: "Pas de nouvelle routine à organiser.", accent: "#1A1918", bg: "#EBEBE9" },
];

export const Why = () => (
  <section data-testid="why-section" className="py-28 sm:py-40">
    <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
      <Reveal><Overline>Pourquoi SOLAMOVE ?</Overline></Reveal>
      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-black/[0.08]">
        {BLOCKS.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.1} className="border-r border-b border-black/[0.08]">
            <div className="group p-8 sm:p-10 h-full min-h-[240px] flex flex-col justify-between transition-colors duration-700" style={{ backgroundColor: b.bg }}>
              <span className="h-2 w-2 rounded-full transition-transform duration-500 group-hover:scale-[2.5]" style={{ backgroundColor: b.accent }} />
              <div>
                <h3 className="font-display uppercase tracking-tight text-2xl sm:text-3xl">{b.title}</h3>
                <p className="mt-4 text-[#6E6A66] leading-relaxed text-sm sm:text-base">{b.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
